import { FormEvent, useState } from "react";

import Geocode from "react-geocode";
import { usePlacesWidget } from "react-google-autocomplete";
const apiKey = "AIzaSyDldEugO3NcBg8xoV_vrbH4AuLYuLPOr4I";
Geocode.setApiKey(apiKey);

function SearchBar(props: {
  fetchData: any;
  loading: boolean;
  useCurrentLocation: boolean;
}) {
  const { fetchData, loading, useCurrentLocation = false } = props;
  const [locationLoading, setLocationLoading] = useState<boolean>(false);

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (ref.current.value) {
      fetchData(ref.current.value);
    }
  };

  function getLocation() {
    setLocationLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        console.log(pos.coords.latitude, pos.coords.longitude);
        Geocode.enableDebug();
        Geocode.fromLatLng(
          pos.coords.latitude.toString(),
          pos.coords.longitude.toString()
        ).then(
          (response) => {
            const address = response.results[0].formatted_address;
            ref.current.value = address;
            setLocationLoading(false);
          },
          (error) => {
            setLocationLoading(false);
            console.error(error);
          }
        );
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }

  // const { ref }: any = usePlacesWidget({
  //   apiKey: apiKey,
  //   options: {
  //     country: "us",
  //     componentRestrictions: { country: "us" },
  //     types: ["street_address"],
  //     fields: ["formatted_address"],
  //   },
  //   onPlaceSelected: (place) => {
  //     console.log(place);
  //     ref.current.value = place.formatted_address;
  //   },
  // });

  const { ref }: any = usePlacesWidget({
    apiKey: apiKey,
    options: {
      country: "us",
      componentRestrictions: { country: "us" },
      fields: [
        "address_components",
        "formatted_address",
        "name",
        "place_id",
        "reference",
        "adr_address",
      ],
      types: ["address"],
    },

    onPlaceSelected: (place) => {
      console.log({ place });

      if (place && place.address_components.length > 0) {
        ref.current.value = place.formatted_address;
      }
      // ref.current.focus();
    },
  });

  return (
    <div className="renew-search-container">
      <div className="renew-search-lookup-form">
        <input className="renew-search-bar-input" ref={ref} />
        <button
          className="renew-primary-button"
          disabled={loading}
          type="button"
          onClick={onSubmit}
        >
          <span>Look Up</span>
        </button>
      </div>
      {useCurrentLocation ? (
        <div>
          <button
            className="renew-outline-button"
            onClick={getLocation}
            disabled={locationLoading}
          >
            <span>Use current location</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default SearchBar;
